import React from "react";
import { useStyles } from "./styles";
import { ContactsProps } from "./types";

export const Contacts = (props: ContactsProps) => {
    const classes = useStyles();
    return (
        <div className={classes.contactsContainer}>
            {props.sale &&
                <a className={classes.contactItem} href={props.sale?.href.toLowerCase()}>
                    {props.sale.text}
                </a>
            }
            {props.support &&
                <a className={classes.contactItem} href={props.support?.href.toLowerCase()}>
                    {props.support.text}
                </a>
            }
            {props.phone &&
                <a className={classes.contactItem} href={props.phone?.href.toLowerCase()}>
                    {props.phone.text}
                </a>
            }
        </div>
    );
};
